/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some sites round intermediate steps (like rounding 0.3048 to 0.305) before finishing the calculation, which introduces small errors that compound over larger numbers. This tool keeps full floating-point precision through the entire calculation and only rounds the final displayed result, so it stays accurate even for large values.`)
};

const es_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunos sitios redondean pasos intermedios (como redondear 0.3048 a 0.305) antes de terminar el cálculo, lo que introduce pequeños errores que se acumulan para números más grandes. Esta herramienta mantiene precisión completa de punto flotante durante todo el cálculo y solo redondea el resultado final mostrado, así que se mantiene precisa incluso para valores grandes.`)
};

const de_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manche Websites runden Zwischenschritte (etwa 0.3048 auf 0.305), bevor die Berechnung abgeschlossen ist, was bei größeren Zahlen kleine Fehler aufsummiert. Dieses Tool behält während der gesamten Berechnung die volle Gleitkomma-Genauigkeit bei und rundet erst das endgültig angezeigte Ergebnis, sodass es auch bei großen Werten präzise bleibt.`)
};

const nl_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommige sites ronden tussenstappen af (zoals 0,3048 afronden naar 0,305) voordat zij de berekening voltooien, wat kleine fouten introduceert die zich ophopen over grotere getallen. Deze tool behoudt volledige drijvende-kommaprecisie door de volledige berekening en rondt alleen het eindresultaat af, dus hij blijft nauwkeurig zelfs voor grote waarden.`)
};

const fr_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains sites arrondissent les étapes intermédiaires (comme arrondir 0,3048 à 0,305) avant de terminer le calcul, ce qui introduit de petites erreurs qui s'accumulent sur les plus grands nombres. Cet outil conserve la précision complète en virgule flottante tout au long du calcul entier et n'arrondit que le résultat final affiché, donc il reste précis même pour les grandes valeurs.`)
};

const it_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcuni siti arrotondano i passaggi intermedi (come arrotondare 0,3048 a 0,305) prima di completare il calcolo, il che introduce piccoli errori che si compongono su numeri più grandi. Questo strumento mantiene la precisione in virgola mobile completa attraverso l'intero calcolo e arrotonda solo il risultato finale visualizzato, quindi rimane accurato anche per valori grandi.`)
};

const pt_br2_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns sites arredondam etapas intermediárias (como arredondar 0.3048 para 0.305) antes de terminar o cálculo, o que introduz pequenos erros que se compõem em números maiores. Esta ferramenta mantém precisão completa de ponto flutuante através de todo o cálculo e apenas arredonda o resultado exibido final, então permanece precisa até mesmo para valores grandes.`)
};

const pt_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns sites arredondam passos intermédios (como arredondar 0,3048 para 0,305) antes de terminar o cálculo, o que introduz pequenos erros que se acumulam sobre números maiores. Esta ferramenta mantém precisão total de ponto flutuante através de todo o cálculo e apenas arredonda o resultado final apresentado, portanto mantém-se precisa mesmo para valores grandes.`)
};

const ja_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部のサイトは中間ステップを丸めます(例えば0.3048を0.305に丸めてから計算を完了する)。これにより小さな誤差が導入され、大きな数値でも複合します。このツールは計算全体を通じて完全な浮動小数点精度を保ち、表示される結果のみを丸めるため、大きな値でも正確なままです。`)
};

const zh_uc_len_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq4_a", locale)
	if (locale === "en") return en_uc_len_faq4_a(inputs)
	if (locale === "es") return es_uc_len_faq4_a(inputs)
	if (locale === "de") return de_uc_len_faq4_a(inputs)
	if (locale === "nl") return nl_uc_len_faq4_a(inputs)
	if (locale === "fr") return fr_uc_len_faq4_a(inputs)
	if (locale === "it") return it_uc_len_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq4_a(inputs)
	if (locale === "pt") return pt_uc_len_faq4_a(inputs)
	if (locale === "ja") return ja_uc_len_faq4_a(inputs)
	return zh_uc_len_faq4_a(inputs)
};